import { Node } from 'tiptap';

export default class Textarea extends Node {
  // eslint-disable-next-line class-methods-use-this
  get name() {
    return 'textarea';
  }

  // eslint-disable-next-line class-methods-use-this
  get view() {
    return {
      props: ['node'],
      template: `
        <textarea
               :placeholder="node.attrs.placeholder"
               :id="node.attrs.id"
               ref="content"
               :contenteditable="true"/>
      `,
    };
  }

  // eslint-disable-next-line class-methods-use-this
  get schema() {
    return {
      inline: true,
      attrs: {
        placeholder: {
          default: 'Text will go here',
        },
        id: {
          default: null,
        },
      },
      group: 'inline',
      content: 'text*',
      size: 'text*',
      toDOM: node => {
        const { placeholder, id } = node.attrs;
        return [
          'textarea',
          {
            placeholder,
            id,
          },
          0,
        ];
      },
      parseDOM: [
        {
          tag: 'textarea',
          getAttrs: dom => ({
            placeholder: 'Text will go here',
            id: dom.getAttribute('id'),
          }),
        },
      ],
    };
  }

  // eslint-disable-next-line class-methods-use-this
  commands({ type }) {
    return attrs => (state, dispatch) => {
      const { selection } = state;
      const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos;
      const node = type.create(attrs);
      const transaction = state.tr.insert(position, node);
      dispatch(transaction);
    };
  }
}



// WEBPACK FOOTER //
// ./src/includes/textArea.js